import { call, put, takeLatest, all } from 'redux-saga/effects'

import { logException } from '~/logging'

import { updateDashboardSuccess, updateDashboardFailure, ACTION } from './actions'
import { fetchShipments } from './dashboardService'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* handleUpdateDashboardRequested(action: any) {
  const searchTerm = action.payload

  try {
    const { orders } = yield call(fetchShipments, searchTerm)

    yield put(updateDashboardSuccess(orders.sentShipments))
  } catch (error) {
    logException(error)
    if (error instanceof Error) {
      yield put(updateDashboardFailure(error))
    }
  }
}

export function* dashboardSaga() {
  yield all([takeLatest(ACTION.UPDATE_DASHBOARD_REQUESTED, handleUpdateDashboardRequested)])
}
